/** Keep third-party navigation in a separate tab, including deferred section links. */
const script = document.querySelector('script[data-external-links]');
const normalizeHost = (host) => host.toLowerCase().replace(/^www\./, '');
const storeHosts = new Set(
  [window.location.hostname, script?.getAttribute('data-store-domain'), script?.getAttribute('data-permanent-domain')]
    .filter(Boolean)
    .map(normalizeHost)
);

/** @type {WeakMap<HTMLAnchorElement, { target: string | null, rel: string | null }>} */
const originalAttributes = new WeakMap();

/** @param {HTMLAnchorElement} link */
function updateExternalLink(link) {
  let external = false;
  try {
    const url = new URL(link.href, document.baseURI);
    external = (url.protocol === 'https:' || url.protocol === 'http:') && !storeHosts.has(normalizeHost(url.hostname));
  } catch {
    return;
  }

  if (!external) {
    const original = originalAttributes.get(link);
    if (original) {
      for (const name of ['target', 'rel']) {
        if (original[name] === null) link.removeAttribute(name);
        else link.setAttribute(name, original[name]);
      }
      originalAttributes.delete(link);
    }
    return;
  }

  if (!originalAttributes.has(link)) {
    originalAttributes.set(link, { target: link.getAttribute('target'), rel: link.getAttribute('rel') });
  }
  link.target = '_blank';
  link.relList.remove('opener');
  link.relList.add('noopener', 'noreferrer');
}

for (const link of document.querySelectorAll('a[href]')) {
  if (link instanceof HTMLAnchorElement) updateExternalLink(link);
}

/** Configure newly inserted or changed links before native navigation happens.
 * @param {Event} event
 */
function handleLinkInteraction(event) {
  const link = event.composedPath().find((node) => node instanceof HTMLAnchorElement && node.hasAttribute('href'));
  if (link instanceof HTMLAnchorElement) updateExternalLink(link);
}

// Delegation also covers facets, Quick Add and theme-editor section replacement.
for (const event of ['pointerdown', 'focusin', 'contextmenu', 'click', 'auxclick']) {
  document.addEventListener(event, handleLinkInteraction, { capture: true });
}
